import React from "react";
import styled from "styled-components";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { TaskTabsTypes } from "../../../shared/constants/taskTabsTypes";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import trackerHelper from "../../../../../coworker-app/src/helpers/tracker";
import { useTranslation } from "@coworker/locales";
import { FixaText } from "../../../shared/wrappers/FixaText/FixaText";
import { useTeamId, useUID } from "@coworker/app/src/core/auth/useLoggedInUser";
import { findFilterFromFilters } from "@coworker/apprestructured/src/shared/filters/utils/filter/filter";
import { updatedFilterValueFromValues } from "@coworker/apprestructured/src/shared/filters/utils/filter/filtervalue";
import {
  Filter,
  FilterValue,
} from "@coworker/apprestructured/src/shared/filters/types/filter";

const TasksTodosTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  height: 24px;
`;

const Title = styled(FixaText)`
  cursor: pointer;
`;

interface TasksTodosTitleProps {
  title: string;
  tasksCount: number;
  tabType: TaskTabsTypes;
  filters: Filter[];
  filterValues: FilterValue[];
  setFilterValues: (values: FilterValue[]) => void;
}

export const TasksTodosTitle: React.FC<TasksTodosTitleProps> = ({
  title,
  tasksCount,
  tabType,
  filters,
  filterValues,
  setFilterValues,
}) => {
  const teamId = useTeamId();
  const uid = useUID();
  const navigate = useFixaNavigate();
  const { t } = useTranslation();

  const handleViewAllClick = () => {
    const path =
      tabType === TaskTabsTypes.OPEN
        ? "/tasks?tab=open"
        : "/tasks?tab=in_progress";

    const section = tabType === TaskTabsTypes.OPEN ? "open_tasks" : "my_tasks";

    navigate(path);

    const filter = findFilterFromFilters(filters, "assignedTo");
    if (filter) {
      const newFilterValues = updatedFilterValueFromValues(
        filterValues,
        filter,
        {
          filterId: "assignedTo",
          value: path === "/tasks?tab=open" ? teamId : uid,
        }
      );
      setFilterValues(newFilterValues);
    }

    if (path === "/tasks?tab=open") {
      trackerHelper.trackOpenTasksPreview(section);
    } else if (path === "/tasks?tab=in_progress") {
      trackerHelper.trackMyOpenTasksPreview(section);
    }
  };
  return (
    <TasksTodosTitleContainer>
      <Title
        tagName="h2"
        textStyle="Heading.S"
        onClick={() => handleViewAllClick()}
      >
        {title} ({tasksCount})
      </Title>
      {tasksCount > 0 && (
        <FixaButton
          text={t("viewAllString")}
          size="small"
          type="tertiary"
          onClick={() => handleViewAllClick()}
        />
      )}
    </TasksTodosTitleContainer>
  );
};
